// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDrxEDiwsl5UKBJsiNhAqiQEKqtIYb8KB8",
  authDomain: "menu-bcncook.firebaseapp.com",
  projectId: "menu-bcncook",
  storageBucket: "menu-bcncook.firebasestorage.app",
  messagingSenderId: "370352873943",
  appId: "1:370352873943:web:a9d4f01c7977ee7084eb92",
};
const firebaseConfig2 = {
  apiKey: "AIzaSyD8Vz7Ey-UutnW1LznnSkm5j7BrwhYQU24",
  authDomain: "grupobcncook.firebaseapp.com",
  projectId: "grupobcncook",
  storageBucket: "grupobcncook.firebasestorage.app",
  messagingSenderId: "83409508430",
  appId: "1:83409508430:web:fb48cad7c7f8b72910cb1f",
};

// Inicializar la primera aplicación
const app1 = initializeApp(firebaseConfig);

// Inicializar la segunda aplicación con un nombre específico
const app2 = initializeApp(firebaseConfig2, "menuApp");

// Crear instancias de Firestore para ambas aplicaciones
const db = getFirestore(app1); // Base de datos para la primera aplicación
const db2 = getFirestore(app2); // Base de datos para la segunda aplicación

export { db, db2 };
